import { useQuery } from "@tanstack/react-query";

import { useMe } from "./queries";
import DataSvc from "../services/dataSvc";

export const useFaq = () => {
  // FAQ query will fail if the user is not authenticated yet
  const { data: me } = useMe();

  const query = useQuery({
    queryKey: ["faqs"],
    queryFn: () => DataSvc.getAllFaq(),
    enabled: !!me
  });

  return query;
};
